import { usePlanoFeatures } from './usePlanoFeatures'

/**
 * Helpers para gates de seção em modais (plano do dono do workspace).
 */
export function usePlanSectionGate(sectionKeyMap) {
  const planoFeatures = usePlanoFeatures()

  const loadPlanForWorkspace = async (workspaceId) => {
    if (!workspaceId) return null
    return planoFeatures.loadForWorkspace(workspaceId)
  }

  const planBlocked = (sectionKey) => {
    const featureKey = sectionKeyMap[sectionKey]
    if (!featureKey) return false
    return !planoFeatures.can(featureKey)
  }

  const planCan = (featureKey) => planoFeatures.can(featureKey)

  return {
    planoFeatures,
    loadPlanForWorkspace,
    planBlocked,
    planCan
  }
}
